// extracted by mini-css-extract-plugin
export default {"content":"Modal_content__0s4+k"};